const localBaseUrl = "http://localhost:8080";
const devBaseUrl = "http://15.207.251.64:8083";
const stagingBaseUrl = "https://turtle.presolv360.com";

const baseUrl =
  window.location.hostname === "turtle.presolv360.com"
    ? stagingBaseUrl
    : window.location.hostname === "15.207.251.64"
      ? devBaseUrl
      : localBaseUrl;

const baseUrlForAssignments = baseUrl + "/assignments";
const baseUrlForArbitrator = baseUrl + "/arbitrators";
const baseUrlForEnterprise = baseUrl + "/enterprise";

export {
  baseUrl,
  baseUrlForAssignments,
  baseUrlForArbitrator,
  baseUrlForEnterprise,
};
